import React, {Component, Suspense} from "react";
import {SettingContainer, SettingInnerContainer} from "./style";
import {withRouter} from "react-router-dom";
import {TopBar} from "./components/topbar";
import SideBar from "./components/sidebar";
import {FullScreenLoading} from "../../components/loading";
import ResponsiveFix from "../../components/responsiveFix";

class SettingLayout extends Component {
  render() {
    const { Component, route, init } = this.props;
    return (
      <ResponsiveFix>
        <TopBar noShadow/>
        <SettingContainer>
          <SideBar initData={init}/>
          <SettingInnerContainer>
            <Suspense fallback={<FullScreenLoading/>}>
              <Component route={route} />
            </Suspense>
          </SettingInnerContainer>
        </SettingContainer>
      </ResponsiveFix>
    );
  }
}

export default withRouter(SettingLayout);